export default __webpack_public_path__ + "static/media/3.46d39d04.png";